<template>
  <div class="custom_selectbox">
    <div class="wrap_selectbox" :class="{ disabled: disabled }">
      <div
        v-if="!disabled"
        class="selectbox"
        :class="{ open: open }"
        @click="open = !open"
        @keydown.enter.exact.prevent
        @keyup.enter.exact="open = !open"
        v-click-outside="onClose"
        tabindex="0"
      >
        {{ selected }}
      </div>
      <div v-else class="selectbox">
        {{ selected }}
      </div>
      <div v-if="!disabled" class="items" :class="{ selectHide: !open }">
        <perfect-scrollbar class="select_scroll" @click.stop>
          <div v-if="firstItem" class="item" :class="{ selected: value == -1 }">
            {{ firstItem }}
          </div>
          <div
            class="item"
            :class="{ selected: value == idx }"
            v-for="(el, idx) of items"
            :key="idx"
            @click="onChange(idx)"
            @keydown.enter.exact.prevent
            @keyup.enter.exact="onChange(idx)"
            tabindex="0"
          >
            {{ el }}
          </div>
        </perfect-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';

export default {
  components: {
    PerfectScrollbar,
  },
  model: {
    event: 'custom-select',
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    firstItem: {
      type: String,
      default: '',
    },
    value: {
      type: Number,
      default: -1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selected() {
      return this.value >= 0 ? this.items[this.value] : this.firstItem;
    },
  },
  data() {
    return {
      open: false,
    };
  },
  directives: {
    'click-outside': {
      bind(el, binding, vnode) {
        var vm = vnode.context;
        var callback = binding.value;
        el.clickOutsideEvent = (event) => {
          if (!(el == event.target || el.contains(event.target))) {
            return callback.call(vm, event);
          }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
      },
      unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
      },
    },
  },
  methods: {
    onChange: function (value) {
      if (value === '') {
        value = null;
      }
      this.$emit('custom-select', value);
      this.open = false;
    },
    onClose: function () {
      this.open = false;
    },
  },
};
</script>
